import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { ResetPasswordForm } from "@/features/auth/components/ResetPasswordForm";
import { AdgeLogo, Card, CardContent, CardHeader, CardTitle, CardDescription, Button } from "@nexus/ui";
import { Link } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/action")({
  validateSearch: (search: Record<string, unknown>) => ({
    mode: search.mode != null ? String(search.mode) : "",
    oobCode: search.oobCode != null ? String(search.oobCode) : "",
  }),
  component: AuthActionPage,
});

function AuthActionPage() {
  const { t } = useTranslation();
  const { mode, oobCode } = Route.useSearch();
  useDocumentTitle(t("page.title.resetPassword"));

  if (mode === "resetPassword" && oobCode) {
    return <ResetPasswordForm oobCode={oobCode} />;
  }

  // Unknown or unsupported mode
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--background)] p-4">
      <Card className="w-full max-w-sm">
        <CardHeader className="space-y-1 text-start">
          <AdgeLogo className="mb-2 origin-start" aria-label={t("auth.brandName")} />
          <CardTitle className="text-xl font-normal">{t("auth.actionInvalidTitle")}</CardTitle>
          <CardDescription>{t("auth.actionInvalidDescription")}</CardDescription>
        </CardHeader>
        <CardContent>
          <Link to="/login">
            <Button variant="outline" className="w-full">{t("auth.forgotPasswordBackToLogin")}</Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
